module.exports = __webpack_public_path__ + "img/Recurso 16@300xe.560d2d4a.webp";